import { render, staticRenderFns } from "./CoursewareUnitItemDialogSettings.vue?vue&type=template&id=b18b189e&"
import script from "./CoursewareUnitItemDialogSettings.vue?vue&type=script&lang=js&"
export * from "./CoursewareUnitItemDialogSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports